import { getUrl } from '@buffer-mono/shared-utils/bibe'

import { navigateTo } from '~publish/helpers/navigation'

import { actionTypes } from './reducer'

type ProfilesDisconnectedAction = {
  type: string
  service?: string
}

type Next = (action: ProfilesDisconnectedAction) => unknown

export default () =>
  (next: Next) =>
  (action: ProfilesDisconnectedAction): void => {
    next(action)
    switch (action.type) {
      case actionTypes.RECONNECT_PROFILE: {
        const reconnectURL = getUrl(
          'https://publish.buffer.com/settings/channels',
        )
        if (action.service === 'instagram') {
          /**
           * This silly looking code loads an 'img' with the
           * Instagram logout URL, which ensures the user is
           * logged out of Instagram before we send them to
           * reconnect.
           */
          const img = new Image()
          img.addEventListener(
            'error',
            () => {
              navigateTo(reconnectURL)
            },
            { once: true },
          )
          img.src = 'https://www.instagram.com/accounts/logoutin'
          document.getElementsByTagName('head')[0].appendChild(img)
        } else {
          navigateTo(reconnectURL)
        }
        break
      }
      default:
        break
    }
  }
